module.exports = __webpack_public_path__ + "img/avon-fighting-breast-cancer-05.4ff3accf.jpg";